(function () {
  'use strict';

  var POPUP_ID = 'SoraaPopup';
  var COOLDOWN_KEY = 'soraaPopupCooldownUntil';
  var COOLDOWN_TIME = 60 * 60 * 1000; // 1 hour

  function getPopup() {
    return document.getElementById(POPUP_ID);
  }

  /*
   * Check whether popup is currently in cooldown.
   */
  function isPopupInCooldown() {
    try {
      var cooldownUntil = parseInt(
        localStorage.getItem(COOLDOWN_KEY),
        10
      );

      if (!cooldownUntil) {
        return false;
      }

      var now = Date.now();

      if (now < cooldownUntil) {
        return true;
      }

      // Cooldown expired, remove old value.
      localStorage.removeItem(COOLDOWN_KEY);
      return false;

    } catch (error) {
      console.log('Popup cooldown check failed');
      return false;
    }
  }

  /*
   * Start 1-hour cooldown.
   */
  function startPopupCooldown() {
    try {
      var cooldownUntil = Date.now() + COOLDOWN_TIME;

      localStorage.setItem(
        COOLDOWN_KEY,
        cooldownUntil.toString()
      );

    } catch (error) {
      console.log('Popup cooldown save failed');
    }
  }

  function openPopup(popup) {

    /*
     * Safety check:
     * Do not open popup if user closed it or submitted email
     * within the last 1 hour.
     */
    if (isPopupInCooldown()) {
      return;
    }

    popup.classList.add('is-active');
    document.body.classList.add('soraa-popup-open');

    setTimeout(function () {
      var emailInput =
        popup.querySelector('[data-popup-email]');

      if (emailInput) {
        emailInput.focus();
      }
    }, 100);
  }

  function closePopup(popup) {
    popup.classList.remove('is-active');
    document.body.classList.remove('soraa-popup-open');
  }

  function showScreen(popup, screenName) {
    var screens =
      popup.querySelectorAll('[data-popup-screen]');

    screens.forEach(function (screen) {
      var isTarget =
        screen.getAttribute('data-popup-screen') === screenName;

      screen.hidden = !isTarget;
      screen.classList.toggle('is-active', isTarget);
    });
  }

  function bindClose(popup) {
    var closeButtons =
      popup.querySelectorAll('[data-popup-close]');

    closeButtons.forEach(function (button) {

      button.addEventListener('click', function () {

        /*
         * User clicked cross button.
         * Start 1-hour cooldown.
         */
        startPopupCooldown();

        closePopup(popup);
      });

    });
  }

  function bindForm(popup) {
    var form =
      popup.querySelector('#SoraaPopupForm');

    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var emailInput =
        form.querySelector('[data-popup-email]');

      var submitButton =
        form.querySelector('.soraa-popup__submit');

      if (!emailInput || !emailInput.value.trim()) {
        return;
      }

      /*
       * Email successfully submitted.
       * Start 1-hour cooldown immediately.
       */
      startPopupCooldown();

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.innerHTML =
          '<span>UNLOCKING...</span>';
      }

      /*
       * Create hidden iframe so Shopify's customer form
       * can submit without navigating away from the page.
       */
      var iframeName =
        'soraa-newsletter-frame-' + Date.now();

      var iframe =
        document.createElement('iframe');

      iframe.name = iframeName;
      iframe.style.display = 'none';
      iframe.setAttribute('aria-hidden', 'true');

      document.body.appendChild(iframe);

      /*
       * Send Shopify form submission into the hidden iframe.
       */
      form.target = iframeName;
      form.submit();

      /*
       * Move to mystery gift screen without page reload.
       */
      setTimeout(function () {
        showScreen(popup, 'game');

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.innerHTML =
            '<span>UNLOCK & PLAY</span><span class="soraa-popup__arrow">→</span>';
        }

        /*
         * Remove iframe after submission has had time
         * to complete.
         */
        setTimeout(function () {
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }
        }, 3000);

      }, 500);
    });
  }

  function generateCode(reward) {
    var randomPart =
      Math.random()
        .toString(36)
        .substring(2, 8)
        .toUpperCase();

    return 'SORAA' + reward + '-' + randomPart;
  }

  function revealReward(popup, reward) {
    var rewardPercent =
      popup.querySelector('[data-reward-percent]');

    var rewardCode =
      popup.querySelector('[data-reward-code]');

    if (rewardPercent) {
      rewardPercent.textContent = reward;
    }

    if (rewardCode) {
      rewardCode.textContent =
        generateCode(reward);
    }

    showScreen(popup, 'reward');
  }

  function bindGifts(popup) {
    var gifts =
      popup.querySelectorAll('[data-reward]');

    gifts.forEach(function (gift) {

      gift.addEventListener('click', function () {

        if (gift.classList.contains('is-picked')) {
          return;
        }

        gifts.forEach(function (item) {
          item.classList.remove('is-picked');
        });

        gift.classList.add('is-picked');

        var reward =
          gift.getAttribute('data-reward');

        setTimeout(function () {
          revealReward(popup, reward);
        }, 700);
      });

    });
  }

  function bindCopyCode(popup) {
    var copyButton =
      popup.querySelector('[data-copy-code]');

    var codeElement =
      popup.querySelector('[data-reward-code]');

    if (!copyButton || !codeElement) return;

    copyButton.addEventListener('click', function () {

      var code =
        codeElement.textContent.trim();

      if (!code) return;

      navigator.clipboard.writeText(code)
        .then(function () {

          copyButton.textContent = 'COPIED!';

          setTimeout(function () {
            copyButton.textContent = 'COPY CODE';
          }, 1500);

        })
        .catch(function () {
          console.log('Copy failed');
        });
    });
  }

  function bindShopButton(popup) {
    var button =
      popup.querySelector('[data-popup-shop]');

    if (!button) return;

    button.addEventListener('click', function () {
      closePopup(popup);
    });
  }

  function init() {
    var popup = getPopup();

    if (!popup) return;

    bindClose(popup);
    bindForm(popup);
    bindGifts(popup);
    bindCopyCode(popup);
    bindShopButton(popup);

    showScreen(popup, 'email');

    /*
     * Do not even schedule popup opening
     * if cooldown is active.
     */
    if (isPopupInCooldown()) {
      return;
    }

    var delay =
      parseInt(
        popup.getAttribute('data-popup-delay'),
        10
      ) || 0;

    setTimeout(function () {

      /*
       * Check one more time before opening.
       * This handles cases where the cooldown
       * was started while the delay timer was running.
       */
      if (isPopupInCooldown()) {
        return;
      }

      openPopup(popup);

    }, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

})();